export default "__VITE_ASSET__BsPRBzYr__"